import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { SimpleDialog, Button } from "simple-ui-components";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { getTranslation } from "../languageProvider";

const DeletePopup = forwardRef(({ DeleteSuccess }, ref) => {
  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;

  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");
  const [deleteText, setDeleteText] = useState("");
  const [title, setTitle] = useState("");

  // trigger from props
  useImperativeHandle(ref, () => ({
    Delete(ids, title, text) {
      setOpen(true);
      setIdToDelete(ids);
      setTitle(title);
      setDeleteText(text);
    },
  }));
  const handleClose = () => setOpen(false);
  const deleteCompaniesListHandler = () => {
    setOpen(false);
    DeleteSuccess(idToDelete);
  };

  return (
    open && (
      <Dialog
        theme="default"
        size="sm"
        close={handleClose}
        open={open}
        title={title}
      >
        <DialogBody>{deleteText}</DialogBody>
        <DialogFooter multiple={true}>
          <Button
            type="button"
            clicked={deleteCompaniesListHandler}
            icon={<DeleteOutlineOutlinedIcon />}
            text={getTranslation("0032")}
            className="btn-danger"
            theme="danger"
            style={{ marginLeft: "auto" }}
          />
        </DialogFooter>
      </Dialog>
    )
  );
});
export default DeletePopup;
